import React from 'react';

export const GridLayoutDropPreview = ({
  style,
}: {
  style?: React.CSSProperties;
}) => {
  if (style == null) {
    return null;
  }

  return <div key="drop-preview" className="drop-preview" style={style} />;
};
